import { render, staticRenderFns } from "./ModalIdle.vue?vue&type=template&id=1b5e6e76"
import script from "./ModalIdle.vue?vue&type=script&lang=js"
export * from "./ModalIdle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports